import Info from "@zenith/assets/icons/Info";

interface DeviceSwitchLimitBannerProps {
  countdown: string;
  onContactSupportClick: () => void;
}

const DeviceSwitchLimitBanner = ({
  countdown,
  onContactSupportClick,
}: DeviceSwitchLimitBannerProps) => (
  <div className="xl:3/5 mx-2 mt-5 w-full rounded-[10px] bg-[#5656CA12] p-4 lg:w-4/5">
    <div className="flex items-start gap-3">
      <Info
        className="mt-0.5 flex-shrink-0"
        width={16}
        height={16}
        stroke="#1A1C1F"
      />
      <div>
        <p className="text-base font-medium text-neutral-900">
          Send Money Limit
        </p>
        <p className="mt-1 text-sm text-neutral-900">
          To help keep your account secure, we've applied a temporary transfer
          limit of ₦20,000 for the next 24 hours because you're using a new
          device.
        </p>
        <p className="mt-1 text-sm text-neutral-600">
          If you have any questions or concerns, please contact our{" "}
          <button
            type="button"
            className="font-semibold text-neutral-900 underline"
            onClick={onContactSupportClick}
          >
            support team
          </button>{" "}
          for assistance.
        </p>
        {countdown && (
          <p className="mt-1 text-sm font-semibold text-[#E03E32]">
            Resets in {countdown}
          </p>
        )}
      </div>
    </div>
  </div>
);

export default DeviceSwitchLimitBanner;
